import { WEAPON_CATEGORY } from '../data/weapons.data.js';
import { getMeleeSlashTuning } from './fx/slashFx.js';

export function spawnMeleeSlashFx(game, { weapon, hand = 'right', player, aimX, aimZ, when = 0.2 } = {}) {
  if (!weapon || weapon.category !== WEAPON_CATEGORY.MELEE) return;
  if (!player?.alive) return;
  const tuning = getMeleeSlashTuning(weapon.id);
  const row = tuning?.row;
  game.slashFx.spawnMeleeSlash({
    weaponId: weapon.id,
    hand,
    player,
    aimX,
    aimZ,
    row,
    when,
  });
}


